// import modules into script
import React from "react";

// Create functional component
const Header = () => {
  return (
    <div className="list-books-title">
      <h1>MyReads</h1>
    </div>
  );
};

export default Header;
